import Login from "@/views/auth/Login.vue";
import Password from "@/views/auth/Password.vue";
import ResetPassword from "@/views/auth/ResetPassword.vue";

export default [
  {
    path: "",
    name: "login",
    component: Login
  },
  {
    path: "reset-password",
    name: "resetPassword",
    component: ResetPassword
  },
  {
    path: "reset-password/update",
    name: "resetPasswordUpdate",
    component: Password
  },
  {
    path: "activate",
    name: "activateAccount",
    component: Password
  }
];
